import {getPredictions} from './getPredictions';

export default {
  county: countryCode => getPredictions(countryCode, 'STATES') || [],
  city: countryCode => getPredictions(countryCode, 'CITIES') || [],
  district: countryCode => getPredictions(countryCode, 'DISTRICTS') || [],
};
